import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UrlConfigService {

  headers: HttpHeaders;

  impressumUrl = 'api/config/impressum';
  datenschutzUrl = 'api/config/datenschutz';

  constructor(private http: HttpClient) { }

  getImpressumUrl(): Observable<any>{
    return this.http.get(this.impressumUrl+'/url', {headers: this.headers, responseType: 'text'});
  }

  getDatenschutzUrl(): Observable<any>{
    return this.http.get(this.datenschutzUrl+'/url', {headers: this.headers, responseType: 'text'});
  }

}
